<template>
  <div>
      <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data() {
        return {
            
        }
    },
    mounted() {
        let currencySymbol = this.getCurrencyFormat.currency_symbol
        let currency_display = this.currency_display

        const ctx = document.getElementById(this.id);
        new Chart(ctx, {
            type: "pie",
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            callback: function(value) {
                                return currency_display ? currencySymbol+' '+value : value.toFixed(2)
                            }
                        }
                    }
                }
            }
        })
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Graphs/Pie.vue